/**
 * Identifiers
 */

export default {
  inputPickupLocation: 'pickupLocation',
  inputReturnLocation: 'returnLocation',
  passwordRequirementsList: 'passwordRequirementsList',
};
